import React from 'react';

export default () => {
  return (
    <div
      onClick={() => {
        throw new Error('点击报错');
      }}>
      点击报错
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/pages/ErrorDemo/index.js